import React from "react";
import ReactDOM from "react-dom/client";
import "regenerator-runtime/runtime";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  MemoryRouter,
  HashRouter,
} from "react-router-dom";
import { initializeIcons } from "@fluentui/react";
import ProtectedRoute from "./ProtectedRoute";
import "./index.css";
 
import Layout from "./pages/layout/Layout";
import NoPage from "./pages/NoPage";
import AppEntry from "./pages/AppEntry";
import { AppStateProvider } from "./state/AppProvider";
import Login from "./pages/login/Login";
// import MyProfile from "./pages/MyProfile";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import AdminLayout from "./components/Admin/AdminLayout";
import FieldMapping from "./components/Field_Mapping/Field_Mapping";
import Signup from "./pages/signup/Signup";
import UnauthorizedAccess from "./Unauthorized Access/Unauthorized Access/Unauthorized_Access";
import AuthStart from "./pages/auth/AuthStart";
import Hazard_Detection from "./Hazard Detection/Hazard_Detection";

// import NotAuthorized from "./pages/Notauthorize";
 
initializeIcons();
 
export default function App() {

  const token = localStorage.getItem("AccessToken");
 
  return (
    <AppStateProvider>
   
 <BrowserRouter>

         <Routes>
          
          <Route path="/signin" element={<Login />} />
          <Route path="/auth" element={<AuthStart />} />

      
        <Route path="/signup" element={<Signup />} />

         
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppEntry />
              </ProtectedRoute>
            }
          />

        
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          />

          <Route
            path="/field-mapping"
            element={
              <ProtectedRoute>
                <FieldMapping />
              </ProtectedRoute>
            }
          />

           <Route
            path="/hazar_detection"
            element={
              <ProtectedRoute>
               <Hazard_Detection/>
              </ProtectedRoute>
            }
          />
       
          <Route path="*" element={<NoPage />} />
           {/* <Route path="/not-Authrize" element={<UnauthorizedAccess />} /> */}
             <Route path="/not-Authorize" element={<UnauthorizedAccess />} />
        </Routes>
      {/* <Routes>
       
      

       
        <Route path="*" element={<Navigate to="/signin" replace />} />
      </Routes> */}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </BrowserRouter>
 
    </AppStateProvider>
  );
}
 
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
 
 

